import { useTheme } from '@wistia/vhs';
import styled from 'styled-components';
import type { JSX } from 'react';

const Container = styled.div`
  background: linear-gradient(180deg, #bed8fb 0%, rgb(190 216 251 / 10%) 100%);
  min-height: 100vh;
  min-width: 100%;
  padding-top: 13rem;
`;

const CenteredTitleText = styled.p`
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 400;
  line-height: 3rem;
  text-align: center;
`;

const CenteredText = styled.p`
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2rem;
  text-align: center;
`;

export const EventNotFound = (): JSX.Element => {
  const theme = useTheme();
  const font = JSON.stringify(theme.font.family);

  return (
    <Container>
      <CenteredTitleText style={{ fontFamily: font }}>
        We&rsquo;ve lost this event
      </CenteredTitleText>
      <CenteredText style={{ fontFamily: font }}>
        Sorry, the event you&rsquo;re looking for does not exist or was moved.
      </CenteredText>
    </Container>
  );
};
